import { render, staticRenderFns } from "./LoginChoose.vue?vue&type=template&id=3a7b1460&scoped=true"
import script from "./LoginChoose.vue?vue&type=script&lang=js"
export * from "./LoginChoose.vue?vue&type=script&lang=js"
import style0 from "./LoginChoose.vue?vue&type=style&index=0&id=3a7b1460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b1460",
  null
  
)

export default component.exports